// extracted by mini-css-extract-plugin
export default {"forecast-day":"OneDay_forecast-day__lqbGc"};